import { DateConverter, DateTimeConverter } from 'src/app/core/services/mapper/converters';
import { ContactEngagement } from './contact-engagement';
import { EngagementDetail } from './engagement-detail';
import { EngagementSc } from './engagement-sc';
import { EntrepriseEngagement } from './entreprise-engagement';
import { IntervenantEngagement } from './intervenant-engagement';
import { RefCampagne } from './ref.campagne.model';
import { LaboratoireAnpp } from './laboratoire-anpp.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from '../../../../core/services/mapper/data-property.converter';
import { Entreprise } from '../../../declaration/models/entreprise.model';

export class EngagementBase {
    static jsonMap = {
        id: { key: 'id', optional: true },
        refCampagne: { key: 'refCampagne', converter: new (ClassConverterFactory.build(RefCampagne))() },
        entreprise: { key: 'entreprise', converter: new (ClassConverterFactory.build(EntrepriseEngagement))() },
        utilisationLogo: { key: 'utilisationLogo' },
        activiteProduction: { key: 'activiteProduction' },
        activiteConditionnement: { key: 'activiteConditionnement' },
        engagementAnimationTechnique: { key: 'engagementAnimationTechnique' },
        organismeCertification: { key: 'organismeCertification', converter: new (ClassConverterFactory.build(EntrepriseEngagement))() },
        responsable: { key: 'responsable', converter: new (ClassConverterFactory.build(ContactEngagement))() },
        referent: { key: 'referent', converter: new (ClassConverterFactory.build(ContactEngagement))() },
        conseillerTechnique: { key: 'conseillerTechnique', converter: new (ClassConverterFactory.build(IntervenantEngagement))(), optional: true },
        conseillerTechnique2: { key: 'conseillerTechnique2', converter: new (ClassConverterFactory.build(IntervenantEngagement))(), optional: true },
        listEngagementDetail: { key: 'listEngagementDetail', converter: new (ArrayClassConverterFactory.build(EngagementDetail))(), optional: true },
        listEngagementSc: { key: 'listEngagementSc', converter: new (ArrayClassConverterFactory.build(EngagementSc))(), optional: true },
        dateAudit: { key: 'dateAudit', converter: new DateConverter(), optional: true },
        idStatut: { key: 'idStatut', optional: true },
        libelleStatut: { key: 'libelleStatut', optional: true, default: '' },
        codeStatut: { key: 'codeStatut', optional: true, default: '' },
        libelleStatutPrecedent: { key: 'libelleStatut', optional: true, default: '' },
        codeStatutPrecedent: { key: 'codeStatut', optional: true, default: '' },
        dateEngagement: { key: 'dateEngagement', converter: new DateTimeConverter(), optional: true },
        laboratoireResidus: { key: 'laboratoireResidus', converter: new (ClassConverterFactory.build(LaboratoireAnpp))(), optional: true },
        laboratoireSols: { key: 'laboratoireSols', converter: new (ClassConverterFactory.build(LaboratoireAnpp))(), optional: true }
    };

    public id: number = undefined;
    public refCampagne: RefCampagne;
    public entreprise: EntrepriseEngagement = undefined;
    public utilisationLogo: boolean = undefined;
    public activiteProduction: boolean = undefined;
    public activiteConditionnement: boolean = undefined;
    public engagementAnimationTechnique: boolean = undefined;
    public organismeCertification: EntrepriseEngagement = undefined;
    public responsable: ContactEngagement = undefined;
    public referent: ContactEngagement = undefined;
    public conseillerTechnique: IntervenantEngagement = undefined;
    public conseillerTechnique2: IntervenantEngagement = undefined;
    public listEngagementDetail: EngagementDetail[] = undefined;
    public listEngagementSc: EngagementSc[] = undefined;
    public dateAudit: moment.Moment;
    public idStatut: number = undefined;
    public libelleStatut: string = undefined;
    public codeStatut: string = undefined;
    public libelleStatutPrecedent: string = undefined;
    public codeStatutPrecedent: string = undefined;
    public dateEngagement: moment.Moment = undefined;
    public laboratoireResidus: LaboratoireAnpp = undefined;
    public laboratoireSols: LaboratoireAnpp = undefined;
}
